import { Injectable } from '@angular/core';
import { Jsonp, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switchMap';

import { AppSettings } from "./config.services";
import { UtilsService } from "./utils.service";

declare var jQuery: any;

@Injectable()
export class VisorService {
	private called: boolean = false;
	private subject: Subject<any> = new Subject<any>();
	private subjectDocument: Subject<any> = new Subject<any>();
	private documentAll: any = null;

	constructor(private jsonp: Jsonp, private utils: UtilsService, private http: Http) { }

	public wasCalled(): Observable<any> {
		return this.subject.asObservable();
	}

	public setAjCode(documento: any) {
		this.subject.next(documento);
	}

	public searchText(query: string, ajcode: string) {
		let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/VisorWebService.asmx/SearchBlocksWithTextJsonP';

		let params = new URLSearchParams();
		params.set('ajCode', ajcode);
		params.set('query', query);
		params.set('page', "0");
		params.set('pageSize', "10");
		params.set('callback', 'JSONP_CALLBACK');

		// TODO: Add error handling
		return this.jsonp
			.get(serviceUrl, { search: params })
			.map(response => {
				return response.json();
			});
	}

	public searchArticles(search: string, ajcode: string) {
		let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/VisorWebService.asmx/GetDocumentArtsJsonP';

		let params = new URLSearchParams();
		params.set('q', search); // the user's search value
		params.set('ajcode', ajcode);
		params.set('callback', 'JSONP_CALLBACK');

		this.getCompleteDocument(ajcode, "")
			.subscribe(res => {
				this.documentAll = res;
			});

		// TODO: Add error handling
		return this.jsonp
			.get(serviceUrl, { search: params })
			.map(response => response.json());
	}

	public checkSearchCount() {
		this.getSearchCount().subscribe(t => {
			if (typeof jQuery === "function") {
				let maxSearchLaw = parseInt(jQuery("#max-law-search").val() || "0");
				let maxSearchArt = parseInt(jQuery("#max-art-search").val() || "0");
				if (t.m_Item1 > maxSearchLaw || t.m_Item3 > maxSearchArt) {
					setTimeout(() => {
						jQuery("#findFinishCountdownDialog").modal("show");
					}, 1200);
				}
			}
		});
	}

	public getSearchCount() {
		let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/VisorWebService.asmx/GetSearchCount';

		// TODO: Add error handling
		return this.http
			.get(serviceUrl)
			.map(response => response.json());
	}

	public getCompleteDocument(ajcode: string, article: string) {
		let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/VisorWebService.asmx/GetCompleteDocument';

		let params = new URLSearchParams();
		params.set('ajcode', ajcode);
		params.set('idUsuario', "0");

		// TODO: Add error handling
		return this.http
			.get(serviceUrl, { search: params })
			.map(response => response.json());
	}

	public getNombreSimple(ajcode: string) {
		let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/FiltersWebService.asmx/GetNombreSimple';

		let params = new URLSearchParams();
		params.set('ajcode', ajcode);

		// TODO: Add error handling
		return this.http
			.get(serviceUrl, { search: params })
			.map(response => {
				return response.text();
			});
	}

	public getBlocks(ajcode: string, article: string) {
		return this.subjectDocument.asObservable();

		/*let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/VisorWebService.asmx/GetDocumentArticleExcerpt';

		let params = new URLSearchParams();
		params.set('ajcode', ajcode);
		params.set('article', article); // the user's search value
		params.set('callback', 'JSONP_CALLBACK');

		// TODO: Add error handling
		return this.jsonp
			.get(serviceUrl, { search: params })
			.map(response => {
				let excerpt: any = response.json();
				excerpt.blocks = this.getBlocksFromArticle(article);
				return excerpt;
			});*/
	}

	public getBlocksFromArticle(ajcode: string, article: string) {

		if (!this.documentAll) {
			this.getCompleteDocument(ajcode, article)
				.subscribe(res => {
					this.documentAll = res;
					this.getBlocksFromArticle(ajcode, article)
				});
			return;
		}

		let pages: Array<any> = this.documentAll.pages as Array<any>;
		let blocks: Array<any> = [];
		let prevItem: string = null;
		let nextItem: string = null;
		let articles: Array<string> = [];

		pages.map((page) => {
			let innerBlocks: Array<any> = page.blocks as Array<any>;
			innerBlocks.map((block) => {
				if (block.block["@article"] == article) {
					blocks.push(block);
				}
				articles.push(block.block["@article"]);
			});
		});

		articles = articles.filter((x, i, a) => a.indexOf(x) == i);

		let index = articles.indexOf(article);

		if (index > 0 && index <= (articles.length - 1)) {
			prevItem = articles[index - 1];
		}

		if (index > 0 && index < (articles.length - 1)) {
			nextItem = articles[index + 1];
		}

		let excerpt = {
			document: this.documentAll.document,
			NumberOfPages: this.documentAll.NumberOfPages,
			blocks: blocks,
			prevItem: prevItem,
			nextItem: nextItem
		};

		this.subjectDocument.next(excerpt);
	}

	public getNotes(guid: string) {
		let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/VisorWebService.asmx/NotasPorBloqueJsonP';

		let params = new URLSearchParams();
		params.set('idUsuario', "0");
		params.set('guidBloque', guid); // the user's search value
		params.set('callback', 'JSONP_CALLBACK');

		// TODO: Add error handling
		return this.jsonp
			.get(serviceUrl, { search: params })
			.map(response => {
				return response.json();
			});
	}

	public getComments(guid: string) {
		let serviceUrl = AppSettings.getAPI_ENDPOINT() + '/ws/VisorWebService.asmx/ComentariosPorBloqueJsonP';

		let params = new URLSearchParams();
		params.set('idUsuario', "0");
		params.set('guidBloque', guid); // the user's search value
		params.set('callback', 'JSONP_CALLBACK');

		// TODO: Add error handling
		return this.jsonp
			.get(serviceUrl, { search: params })
			.map(response => {
				return response.json();
			});
	}

	public validateFormatUnit(fUnit: any, modelGUID, ajcode, article) {
		var css = '';
		var style = {};

		if (fUnit.hasOwnProperty('#text')) {
			if (typeof fUnit["#text"] === "string")
				fUnit.text = fUnit['#text'].replace(/&lt;/gi, "< ").replace(/&gt;/gi, " >");

			if (Array.isArray(fUnit["#text"]))
				fUnit.text = fUnit['#text'].join('&#13;&#10;').replace(/&lt;/gi, "< ").replace(/&gt;/gi, " >");
			delete fUnit['#text'];
		}

		//if(fUnit.hasOwnProperty('@color')){
		//    style.color = "rgb("+fUnit['@color']+")";
		//    delete fUnit['@color'];
		//}

		if (fUnit.hasOwnProperty('@isStroked')) {
			style['text-decoration'] = (fUnit['@isStroked'] === 'true') ? 'line-through' : 'none';
			delete fUnit['@isStroked'];
		}

		if (fUnit.hasOwnProperty('@align')) {
			css += 'text-' + fUnit['@align'];
			fUnit.align = fUnit['@align'];
			delete fUnit['@align'];
		}

		if (fUnit.hasOwnProperty('@isBold')) {
			css += 'text-weight' + (fUnit['@isBold'] === 'true') ? 'bold' : 'normal';
			delete fUnit['@isBold'];
		}

		if (fUnit.hasOwnProperty('@isTitle')) {
			fUnit.isTitle = eval(fUnit['@isTitle']);
			delete fUnit['@isTitle'];
		}

		if (fUnit.hasOwnProperty('@isReference')) {
			let urlRefer: string = fUnit['@refParams'];
			if (!this.utils.isNullOrEmpty(urlRefer)) {
				urlRefer = urlRefer.replace("&amp;", "&");
				let originalRefer = urlRefer;

				let article = this.utils.getParameterByName("arts", urlRefer);
				if (!this.utils.isNullOrEmpty(article))
					article = article.split(",")[0];

				let ajcodeUrl = this.utils.getParameterByName("ajcode", urlRefer);

				if (!this.utils.isNullOrEmpty(article)) {
					this.getNombreSimple(ajcodeUrl).subscribe(t => {
						urlRefer = "/" + t + "/articulo/" + article;
						fUnit.url = urlRefer;
						fUnit.route = true;
					});
				} else {
					fUnit.route = false;
					//fUnit.url = originalRefer.replace("document.aspx", "Documento.aspx");
					fUnit.url = originalRefer.replace("document.aspx", "Document.aspx");
					var reMatch = /^\/Document.aspx\?ajcode=(\w+)$/g;
					if (reMatch.test(fUnit.url)) {
						let ajcode = this.utils.getParameterByName("ajcode", fUnit.url);
						this.getNombreSimple(ajcode).subscribe(t => {
							fUnit.url = `/Documents/${t}.aspx`;
						});
					}
				}
			}

			delete fUnit['@refParams'];
			delete fUnit['@isReference'];

		}

		if (fUnit.hasOwnProperty("@refTooltip")) {
			fUnit.tooltip = fUnit['@refTooltip'];
			delete fUnit['@refTooltip'];
		}

		if (Object.keys(style).length == 0 && !this.utils.isNullOrEmpty(css)) { // !this.utils.isNullOrEmpty(css)
			fUnit.css = css;
		}

		if (Object.keys(style).length == 0) {  //!String.isEmpty(style)
			//fUnit.style = style;
		}

		if (typeof fUnit !== "string") {
			fUnit.guid = modelGUID; //$scope.ngModel.block["@GUID"];
			fUnit.src = "";

			if (!fUnit.tooltip)
				fUnit.tooltip = "";
		}

		return fUnit;
	}
}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/services/visor.service.ts